export default __webpack_public_path__ + "static/media/mist.49ef75d3.jpg";